import { render, staticRenderFns } from "./ProductColumnChart.vue?vue&type=template&id=62837780&scoped=true"
import script from "./ProductColumnChart.vue?vue&type=script&lang=js"
export * from "./ProductColumnChart.vue?vue&type=script&lang=js"
import style0 from "./ProductColumnChart.vue?vue&type=style&index=0&id=62837780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62837780",
  null
  
)

export default component.exports